import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (id, payload) =>
  f3tch(`/branches/reduced_deductible_rates/${id}/`)
    .profile(profile())
    .body(payload)
    .patch();
